import { API_URL } from '../../../app-config/constants';
import type { ChatHistory, ContextReference, UserRating } from '../../react/features/AiCopilot/types';
import type { ChatHistoryDto } from '../../react/features/CompanyObserver/pages/AiObserver/types';
import { get, post, remove } from '../request';

const BASE_URL = `${API_URL}/copilot/history`;

type GetHistoryQuery =
    | {
          assistantId: string;
          contextReference?: ContextReference;
      }
    | {
          from: Date;
      };

getHistory.operation = 'READ';
export function getHistory(query: GetHistoryQuery) {
    const from = 'from' in query ? query.from : null;
    return get<ChatHistory[]>(BASE_URL, {
        getData: {
            ...query,
            from: from?.toISOString?.(),
        },
    });
}

getChat.operation = 'READ';
export function getChat(id: string) {
    return get<ChatHistory>(`${BASE_URL}/${id}`);
}

rateAiResponse.operation = 'COMMAND';
export function rateAiResponse(id: string, historyItemId: string, userRating: UserRating) {
    return post<ChatHistory>(`${BASE_URL}/${id}/${historyItemId}`, { postData: userRating });
}

deleteChat.operation = 'DELETE';
deleteChat.invalidates = ['getHistory', 'getChat'];
export function deleteChat(id: string) {
    return remove(`${BASE_URL}/${id}`);
}

invalidate.operation = 'NO_OPERATION';
invalidate.invalidates = ['getHistory'];
export function invalidate() {
    return Promise.resolve();
}

invalidateChat.operation = 'NO_OPERATION';
invalidateChat.invalidates = ['getChat'];
export function invalidateChat() {
    return Promise.resolve();
}

getCompanyObserverHistory.operation = 'READ';
export function getCompanyObserverHistory(companyId: string) {
    return get<ChatHistoryDto[]>(`${API_URL}/ai-observer/company/${companyId}/chat-history`);
}

getUserObserverHistory.operation = 'READ';
export function getUserObserverHistory(userId: string) {
    return get<ChatHistoryDto[]>(`${API_URL}/ai-observer/user/${userId}/chat-history`);
}

deleteChatHistory.operation = 'DELETE';
deleteChatHistory.invalidates = ['getCompanyObserverHistory', 'getUserObserverHistory'];
export function deleteChatHistory(id: string) {
    return remove(`${API_URL}/ai-observer/chat-history/${id}`);
}
